import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { EmptyState, Phone01 } from '@opendate-app/setlist';
import SmsOptOutToggle from '../../../shared/SmsOptOutToggle';
import DataTable from '../../DataTable/components/DataTable';
const axios = require('axios').default;
import AsyncSelect from 'react-select/async';
import { mergeSelectStyles } from '../../../shared/darkSelectStyles';

import jsxToString from 'jsx-to-string';
var ReactDOM = require('react-dom');
import Popup from "reactjs-popup";
import { ToastContainer } from 'react-toastify';

import $ from 'jquery';
require('datatables.net-bs4');

var _ = require('lodash');
var debouncedFetchEstimatedNumberOfSends;

const canSubmitForm = (textMessage, isSubmitting) => {
  return (
    textMessage
      && textMessage.venue_ownership_id
      && textMessage.calendar_events
      && textMessage.calendar_events.length > 0
      && textMessage.message
      && textMessage.message.length > 0
      && !isSubmitting
  );
}

const debouncedConfirmFetch = _.debounce((inputValue, callback, team, venueOwnershipId) => {
  new Promise(resolve => {
    axios.get('/teams/' + team.id + '/calendar_events/autocomplete', {
        params: {
          name: inputValue,
          venue_ownership_id: venueOwnershipId,
          confirm_only: true,
          only_future: false
        }
      })
      .then(function (response) {
        var options = response.data.map(function(data){
          return { value: data.id, label: data.name };
        });

        callback(options);
      })
  });
}, 250);

const modalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "840px",
  "padding": "15px"
}

const selectStyles = mergeSelectStyles({
  container: base => ({ ...base, zIndex: "999", fontSize: "16px" }),
  control: base => ({ ...base, border: "1px solid var(--od-c-e6e6e6, #e6e6e6)" }),
  placeholder: base => ({ ...base, color: "var(--od-c-495057, #495057)" })
});

const TextMessages = ({
  csrfToken,
  team,
  currentUser,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  dataTableEl,
  dataTableElChanged,
  searchedSearchTerm,
  textMessage,
  fetchNewTextMessage,
  textMessageChanged,
  venueOwnerships,
  createTextMessage,
  isSubmitting,
  fetchEstimatedNumberOfSends,
  estimatedNumberOfSends,
  estimatedNumberOfSendsChanged,
  hasTextMessages,
}) => {
  useEffect(() => {
    debouncedFetchEstimatedNumberOfSends = _.debounce((team, textMessage) => {
      fetchEstimatedNumberOfSends(team, textMessage);
    }, 250);
  }, []);

  return (
    <div>
      <ToastContainer icon={false} />
      {!hasTextMessages ? (
        <div className='row'>
          <div className='col-12'>
            <div className='card border-0 shadow-2'>
              <div className='card-body'>
                <p style={{'fontSize': '20px'}}>
                  <strong>
                    SMS Messages&nbsp;
                    <span className='text-muted'>(0)</span>
                  </strong>
                </p>
              </div>
              <div className='card-body' style={{'paddingBottom': '456px', "paddingTop": "11px"}}>
                <EmptyState
                  icon={Phone01}
                  title="No SMS Messages"
                  description="Create your first SMS message to your fans."
                  primaryAction={currentUser.can_manage_text_messages ? {
                    label: 'Create an SMS Message',
                    onClick: () => fetchNewTextMessage(csrfToken, team),
                  } : undefined}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <React.Fragment>
          <div className="datatable-right-header-section">
            <a href="#"
               onClick={(e) => {
                 e.preventDefault();
                 fetchNewTextMessage(csrfToken, team);
               }}
               className="btn btn-primary">
              <i className="fal fa-plus"></i>
              &nbsp;
              <strong>New Text Message</strong>
            </a>
          </div>
          <DataTable title={dataTableTitle}
                     dataSource={dataTableDataSource}
                     columns={dataTableColumns}
                     colGroup={
                       <colgroup>
                         <col span={1} style={{"width": "20%"}} />
                         <col span={1} style={{"width": "10%"}} />
                         <col span={1} style={{"width": "40%"}} />
                         <col span={1} style={{"width": "30%"}} />
                       </colgroup>
                     }
                     onTableElementSet={
                       (el) => {
                         dataTableElChanged(el);
                       }
                     }
                     searchedSearchTerm={searchedSearchTerm}
                     order={dataTableOrder} />
        </React.Fragment>
      )}
      <Popup
       open={Object.keys(textMessage).length > 0}
       contentStyle={modalContentStyle}
       className={"popup-modal"}
       closeOnDocumentClick={false}
       onOpen={
         () => {
           estimatedNumberOfSendsChanged(0);
         }
       }
       onClose={() => textMessageChanged({})}
      >
        <div className="row popup-modal-container">
          <div className="col-12">
            <div className="row">
              <div className="col d-flex align-items-center">
                <p className="mb-0"
                   style={{"fontSize": "24px"}}>
                  <strong>New Text Message</strong>
                </p>
              </div>
              <div className="col-xs-auto d-flex align-items-center"
                   style={{"paddingRight": "15px"}}>
                <a onClick={
                     (e) => {
                       e.preventDefault();
                       textMessageChanged({});
                     }
                   }
                   className="text-dark"
                   href="#">
                  <i className="fal fa-times" style={{"fontSize": "24px"}}></i>
                </a>
              </div>
            </div>
            <form onSubmit={
                    (e) => {
                      e.preventDefault();

                      if(!canSubmitForm(textMessage, isSubmitting)){
                        return false;
                      }

                      createTextMessage(csrfToken, team, textMessage, dataTableEl);
                    }
                  }>
              <div className="row" style={{"marginTop": "28px"}}>
                <div className="col-12 col-md-6 col-lg-8">
                  <div className="form-group">
                    <label htmlFor={"text-message-venue-ownership"}
                           className="text-muted mb-1"
                           style={{"fontSize": "14px"}}>
                      Venue
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <select className="form-control"
                            style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)"}}
                            onChange={
                              (e) => {
                                var updated = Object.assign({}, textMessage, {
                                  venue_ownership_id: e.target.value,
                                  calendar_events: []
                                });

                                estimatedNumberOfSendsChanged(0);
                                textMessageChanged(updated);
                              }
                            }
                            id={"text-message-venue-ownership"}
                            value={textMessage.venue_ownership_id || ""}>
                      <option value="" disabled>Select venue</option>
                      {venueOwnerships.map((venueOwnership, index) =>
                        <option key={index} value={venueOwnership.id}>
                          {venueOwnership.venueable.name}
                        </option>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-8">
                  <div className="form-group">
                    <label htmlFor={"text-message-confirm"}
                           className="text-muted mb-1"
                           style={{"fontSize": "14px"}}>
                      Events
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <AsyncSelect isMulti={true}
                                 cacheOptions={false}
                                 placeholder={"Enter an event name..."}
                                 isClearable={true}
                                 styles={selectStyles}
                                 isDisabled={!textMessage.venue_ownership_id}
                                 menuPortalTarget={document.querySelector('body')}
                                 defaultOptions={false}
                                 id="text-message-confirm"
                                 onChange={
                                   (options) => {
                                      var updated = {...textMessage, calendar_events: (options || [])};

                                      debouncedFetchEstimatedNumberOfSends(team, updated);
                                      textMessageChanged(updated);
                                   }
                                 }
                                 value={textMessage.calendar_events || ""}
                                 loadOptions={
                                   (inputValue, callback) => {
                                     return debouncedConfirmFetch(inputValue, callback, team, textMessage.venue_ownership_id);
                                   }
                                 } />
                    <p className="mb-0 small text-muted">
                      {estimatedNumberOfSends.toLocaleString("en-US")} fan(s)
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor={"text-message-message"}
                       className="text-muted mb-1"
                       style={{"fontSize": "14px"}}>
                  Message
                  <span className="text-danger">&nbsp;*</span>
                </label>
                <textarea className="form-control"
                          style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)"}}
                          value={textMessage.message || ""}
                          onChange={
                            (e) => {
                              var updated = Object.assign({}, textMessage, {
                                message: e.target.value
                              });

                              textMessageChanged(updated);
                            }
                          }
                          id="text-message-message"
                          rows="3">
                </textarea>
              </div>
              <SmsOptOutToggle
                text={textMessage.message}
                onChange={
                  (message) => {
                    textMessageChanged(Object.assign({}, textMessage, { message }));
                  }
                }
                style={{ marginBottom: 16 }}
              />
              <div className="row mt-3">
                <div className="col-12 text-right">
                  <button type="submit"
                          disabled={!canSubmitForm(textMessage, isSubmitting)}
                          className="btn btn-primary">
                    {isSubmitting ? (
                      <React.Fragment>
                        <img src="/uploading-loading.gif"
                             className="mr-1"
                             style={{width: "16px"}} />
                        <strong>Sending...</strong>
                      </React.Fragment>
                    ) : (
                      <strong>Send</strong>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  )
};

TextMessages.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableTitle: PropTypes.string.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  dataTableOrder: PropTypes.array,
  dataTableColumns: PropTypes.array.isRequired,
  dataTableEl: PropTypes.object,
  dataTableElChanged: PropTypes.func.isRequired,
  searchedSearchTerm: PropTypes.string,
  textMessage: PropTypes.object,
  fetchNewTextMessage: PropTypes.func.isRequired,
  textMessageChanged: PropTypes.func.isRequired,
  venueOwnerships: PropTypes.array,
  createTextMessage: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  fetchEstimatedNumberOfSends: PropTypes.func.isRequired,
  estimatedNumberOfSends: PropTypes.number,
  estimatedNumberOfSendsChanged: PropTypes.func.isRequired,
  hasTextMessages: PropTypes.bool.isRequired,
};

export default TextMessages;
